import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';

import { handleRedirection } from 'utils/utils';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function Discrepancy() {
  const { caseDetails, isCaseFileManager } = useFileManagerContext();
  const history = useHistory();

  const handleDiscrepancy = () => {
    const caseDataToPass = {};
    caseDataToPass['case_name'] = caseDetails?.case_description?.case_name;

    if (Object.keys(caseDataToPass)?.length > 0) {
      localStorage.setItem('caseData', JSON.stringify(caseDataToPass));
    }
    const url = `/discrepancy/${isCaseFileManager ? 'cases' : 'leads'}/${caseDetails?.case_id}`;
    handleRedirection(history, url, caseDataToPass);
  };

  return (
    <Button className="files-sq-button discrepancy pointer grid-view-style" onClick={handleDiscrepancy}>
      <Tooltip content="Identify Discrepancies" position="top" target=".discrepancy" style={{ top: 0 }} showDelay={500} />
      <i className="bi bi-magic"></i>
    </Button>
  );
}

export default Discrepancy;
